import React from "react";
import "./App.css";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Login from "./screens/Login";
import ForgotPassword from "./screens/Login/forgotpassword";
import Dashboard from "./screens/Dashboard";
import Checklist from "./screens/Checklist";
import Defects from "./screens/Defects";
import Repairs from "./screens/Repairs";
import Masters from "./screens/Masters";
import Account from "./screens/Account";
import ChecklistMaster from "./screens/Masters/ChecklistMaster";
import ChecklistTypeMaster from "./screens/Masters/ChecklistTypeMaster";
import SupportMaster from "./screens/Masters/SupportMaster";
import EditDefectDetails from "./screens/Defects/EditDefectDetails";
import VesselAdminMaster from "./screens/Masters/VesselAdminMaster";
import CompanyAdminMaster from "./screens/Masters/CompanyAdminMaster";
import ManagementMaster from "./screens/Masters/ManagementMaster";
import DepartmentMaster from "./screens/Masters/DepartmentMaster";
import VesselTypeMaster from "./screens/Masters/VesselTypeMaster";
import VesselMaster from "./screens/Masters/VesselMaster";
import ProtectedRoute from "./utils/ProtectedRoute";
import { ToastContainer, Slide } from "react-toastify";
import RoleMaster from "./screens/Masters/RoleMaster";
import ScreenAccessMaster from "./screens/Masters/ScreenAccessMaster";
import RolePermissionMaster from "./screens/Masters/RolePermissionMaster";
import SuperintendentMaster from "./screens/Masters/SuperintendentMaster";
import ChecklistGracePeriod from "./screens/Masters/ChecklistGracePeriod";
import QuestionMaster from "./screens/Masters/QuestionMaster";
import MobileViewPage from "./components/MobileView/mobileViewPage";
import NotificationBroadcast from "./screens/Masters/NotificationBroadcast";
import DefectMaster from "./screens/Masters/DefectMaster";
import ViewDefectDetails from "./screens/Defects/ViewDefectDetails";
import { useSelector } from "react-redux";

// const hasPermission = (userPermissions, screenName) => {
//   const permission = userPermissions?.find(
//     (permission) =>
//       permission.screen.name === screenName && permission.screen.active
//   );
//   return permission !== undefined;
// };

function App() {

  const userData = useSelector((state) => state?.user?.userData);
  const userPermission = useSelector(
    (state) => state?.user?.userData?.userRolePermission
  );

  return (
    <Box className="app__globalContainer">
      <ToastContainer />
      <Router>
        <Routes>
          {/* ---------------------------------------authentication route------------------------------------------------ */}
          <Route exact path="/" element={<Login />} />
          <Route exact path="/forgotpassword" element={<ForgotPassword />} />

          {/* ---------------------------------------sidebar route------------------------------------------------ */}

          {/* {hasPermission(userData?.userRolePermission, "Dashboard_Menu") && (
              <Route
                path="/dashboard"
                element={<ProtectedRoute Component={Dashboard} />}
              />
            )} */}
          <Route
            exact
            path="/dashboard"
            element={<ProtectedRoute Component={Dashboard} />}
          />

          {/* {hasPermission(userData?.userRolePermission, "Checklist_Menu") && (
              <Route
                path="/checklist"
                element={<ProtectedRoute Component={Checklist} />}
              />
            )} */}

          <Route
            exact
            path="/checklist"
            element={
              <ProtectedRoute
                Component={Checklist}
                value={"Checklist_Menu"}
              />
            }
          />

          {/* {hasPermission(userData?.userRolePermission, "Defects_Menu") && (
              <Route
                path="/defects"
                element={<ProtectedRoute Component={Defects} />}
              />
            )} */}

          <Route
            exact
            path="/defects"
            element={
              <ProtectedRoute Component={Defects} value={"Defects_Menu"} />
            }
          />

          {/* {hasPermission(userData?.userRolePermission, "Repairs_Menu") && (
              <Route
                path="/repairs"
                element={<ProtectedRoute Component={Repairs} />}
              />
            )} */}

          <Route
            exact
            path="/repairs"
            element={
              <ProtectedRoute Component={Repairs} value={"Repairs_Menu"} />
            }
          />

          {/* {hasPermission(userData?.userRolePermission, "Masters_Menu") && (
              <Route
                path="/masters"
                element={<ProtectedRoute Component={Masters} />}
              />
            )} */}
          <Route
            exact
            path="/masters"
            element={
              <ProtectedRoute Component={Masters} value={"Masters_Menu"} />
            }
          />

          {/* {hasPermission(userData?.userRolePermission, "Account") && (
              <Route
                path="/account"
                element={<ProtectedRoute Component={Account} />}
              />
            )} */}

          <Route
            exact
            path="/account"
            element={<ProtectedRoute Component={Account} />}
          />

          {/* ---------------------------------------sidebar children route------------------------------------------------ */}

          <Route
            exact
            path="/defects/editdefectdetails"
            element={<ProtectedRoute Component={EditDefectDetails} />}
          />

          <Route
            exact
            path="/defects/viewdefectdetails"
            element={<ProtectedRoute Component={ViewDefectDetails} />}
          />

          <Route
            exact
            path="/masters/vesseladminmaster"
            element={
              <ProtectedRoute
                Component={VesselAdminMaster}
                value={"Vessel_Admin_Master"}
              />
            }
          />

          <Route
            exact
            path="/masters/companyadminmaster"
            element={
              <ProtectedRoute
                Component={CompanyAdminMaster}
                value={"Company_Admin_Master"}
              />
            }
          />

          <Route
            exact
            path="/masters/managementadminmaster"
            element={
              <ProtectedRoute
                Component={ManagementMaster}
                value={"Management_User_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/vesseltypemaster"
            element={
              <ProtectedRoute
                Component={VesselTypeMaster}
                value={"Vessel_Type_Master"}
              />
            }
          />

          <Route
            exact
            path="/masters/vesselmaster"
            element={
              <ProtectedRoute
                Component={VesselMaster}
                value={"Vessel_Master"}
              />
            }
          />

          <Route
            exact
            path="/masters/checklistmaster"
            element={
              <ProtectedRoute
                Component={ChecklistMaster}
                value={"Checklist_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/checklisttypemaster"
            element={
              <ProtectedRoute
                Component={ChecklistTypeMaster}
                value={"Checklist_Type_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/supportmaster"
            element={
              <ProtectedRoute
                Component={SupportMaster}
                value={"Support_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/checklistgraceperiod"
            element={<ProtectedRoute Component={ChecklistGracePeriod} />}
          />
          <Route
            exact
            path="/masters/departmentmaster"
            element={
              <ProtectedRoute
                Component={DepartmentMaster}
                value={"Department_Master"}
              />
            }
          />

          <Route
            exact
            path="/masters/rolemaster"
            element={
              <ProtectedRoute Component={RoleMaster} value={"Role_Master"} />
            }
          />
          <Route
            exact
            path="/masters/superintendentmaster"
            element={
              <ProtectedRoute
                Component={SuperintendentMaster}
                value={"Superintendent_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/screenaccessmaster"
            element={
              <ProtectedRoute
                Component={ScreenAccessMaster}
                value={"Screen_Access_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/rolepermissionmaster"
            element={
              <ProtectedRoute
                Component={RolePermissionMaster}
                value={"Role_Permission_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/checklistquestionmaster"
            element={
              <ProtectedRoute
                Component={QuestionMaster}
                value={"Checklist_Question_Master"}
              />
            }
          />
          <Route
            exact
            path="/masters/sendnotification"
            element={
              <ProtectedRoute
                Component={NotificationBroadcast}
                value={"Notification_Broadcast"}
              />
            }
          />
          <Route
            exact
            path="/masters/defectmaster"
            element={<ProtectedRoute Component={DefectMaster} />}
          />
        </Routes>

      </Router>
    </Box>
  );
}

export default App;
